import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class WoredaDataService {
  private woredaDataSubject = new BehaviorSubject<any>(null);
  woredaData$ = this.woredaDataSubject.asObservable();

  setWoredaData(data: any): void {
    this.woredaDataSubject.next(data);
  }

  getWoredaData() {
    return this.woredaDataSubject.getValue();
  }

  getWoredaByKey(key: string): any {
    const woredaData = this.getWoredaData();
    return woredaData ? woredaData[key] : null;
  }
}
